/* eslint-disable @typescript-eslint/member-ordering */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { interpolateParams } from 'src/app/shared/utilities/interpolate-params';
import { combine } from 'src/app/shared/utilities/route';
import { Houseware } from '../models/houseware.model';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';

export interface Furniture {
    fDelivery: number;
    furniture: number;
    utilities: number;
}

export interface HousingModel {
    extendedStay: number;
    fAmount: number;
    familyAge: string;
    familyComment: string;
    familyName: string;
    fmsg: string;
    furnitures: Furniture[];
    furnituresIncluded: boolean;
    hBed: number;
    hType: number;
    hospitalId: number;
    isLease: boolean;
    isUtilityIncluded: boolean;
    monthlyHousing: number;
    petAge: string;
    petBreed: string;
    petId: number;
    petWeight: string;
}

@Injectable({
    providedIn: 'root'
})
export class MarginCalculatorHousingService extends MarginCalculatorBaseService {
    constructor(private readonly _http: HttpClient) {
        super();
    }

    getHousewares(): Observable<Houseware[]> {
        const url = combine(this.coreApiPath, 'margin-calculator/housewares');
        return this._http.get<Houseware[]>(url);
    }

    getHousingInfo(nurseId: number, facilityId: number, marginId = 0, isExtended = false): Observable<HousingModel> {
        const url = combine(this.coreApiPath, 'margin-calculator/housing');
        const params = interpolateParams({ userId: nurseId, hospitalId: facilityId, marginId, isExtended });
        return this._http.get<HousingModel>(url, { params });
    }
}
